/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseTemplateDto } from '../models/base-template-dto';
import { BaseTemplateDtoPage } from '../models/base-template-dto-page';
import { createTemplate } from '../fn/templates/create-template';
import { CreateTemplate$Params } from '../fn/templates/create-template';
import { deleteTemplate } from '../fn/templates/delete-template';
import { DeleteTemplate$Params } from '../fn/templates/delete-template';
import { exportTemplates } from '../fn/templates/export-templates';
import { ExportTemplates$Params } from '../fn/templates/export-templates';
import { getTemplate } from '../fn/templates/get-template';
import { GetTemplate$Params } from '../fn/templates/get-template';
import { getTemplateDynamicForms } from '../fn/templates/get-template-dynamic-forms';
import { GetTemplateDynamicForms$Params } from '../fn/templates/get-template-dynamic-forms';
import { importTemplates } from '../fn/templates/import-templates';
import { ImportTemplates$Params } from '../fn/templates/import-templates';
import { listTemplates } from '../fn/templates/list-templates';
import { ListTemplates$Params } from '../fn/templates/list-templates';
import { updateTemplate } from '../fn/templates/update-template';
import { UpdateTemplate$Params } from '../fn/templates/update-template';
import { updateTemplateDynamicFormsSchema } from '../fn/templates/update-template-dynamic-forms-schema';
import { UpdateTemplateDynamicFormsSchema$Params } from '../fn/templates/update-template-dynamic-forms-schema';
import { WorkPackageDynamicFormsDto } from '../models/work-package-dynamic-forms-dto';

@Injectable({ providedIn: 'root' })
export class TemplatesApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listTemplates()` */
  static readonly ListTemplatesPath = '/v0/templates';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listTemplates()` instead.
   *
   * This method doesn't expect any request body.
   */
  listTemplates$Response(params?: ListTemplates$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseTemplateDtoPage>> {
    return listTemplates(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listTemplates$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listTemplates(params?: ListTemplates$Params, context?: HttpContext): Observable<BaseTemplateDtoPage> {
    return this.listTemplates$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseTemplateDtoPage>): BaseTemplateDtoPage => r.body)
    );
  }

  /** Path part for operation `createTemplate()` */
  static readonly CreateTemplatePath = '/v0/templates';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createTemplate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTemplate$Response(params: CreateTemplate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseTemplateDto>> {
    return createTemplate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createTemplate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTemplate(params: CreateTemplate$Params, context?: HttpContext): Observable<BaseTemplateDto> {
    return this.createTemplate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseTemplateDto>): BaseTemplateDto => r.body)
    );
  }

  /** Path part for operation `getTemplate()` */
  static readonly GetTemplatePath = '/v0/templates/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTemplate()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTemplate$Response(params: GetTemplate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseTemplateDto>> {
    return getTemplate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTemplate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTemplate(params: GetTemplate$Params, context?: HttpContext): Observable<BaseTemplateDto> {
    return this.getTemplate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseTemplateDto>): BaseTemplateDto => r.body)
    );
  }

  /** Path part for operation `updateTemplate()` */
  static readonly UpdateTemplatePath = '/v0/templates/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTemplate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTemplate$Response(params: UpdateTemplate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateTemplate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateTemplate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTemplate(params: UpdateTemplate$Params, context?: HttpContext): Observable<void> {
    return this.updateTemplate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteTemplate()` */
  static readonly DeleteTemplatePath = '/v0/templates/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteTemplate()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTemplate$Response(params: DeleteTemplate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteTemplate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteTemplate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTemplate(params: DeleteTemplate$Params, context?: HttpContext): Observable<void> {
    return this.deleteTemplate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getTemplateDynamicForms()` */
  static readonly GetTemplateDynamicFormsPath = '/v0/templates/{id}/dynamic-forms';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTemplateDynamicForms()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTemplateDynamicForms$Response(params: GetTemplateDynamicForms$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackageDynamicFormsDto>> {
    return getTemplateDynamicForms(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTemplateDynamicForms$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTemplateDynamicForms(params: GetTemplateDynamicForms$Params, context?: HttpContext): Observable<WorkPackageDynamicFormsDto> {
    return this.getTemplateDynamicForms$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPackageDynamicFormsDto>): WorkPackageDynamicFormsDto => r.body)
    );
  }

  /** Path part for operation `updateTemplateDynamicFormsSchema()` */
  static readonly UpdateTemplateDynamicFormsSchemaPath = '/v0/templates/{id}/dynamic-forms-schema';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTemplateDynamicFormsSchema()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTemplateDynamicFormsSchema$Response(params: UpdateTemplateDynamicFormsSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateTemplateDynamicFormsSchema(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateTemplateDynamicFormsSchema$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTemplateDynamicFormsSchema(params: UpdateTemplateDynamicFormsSchema$Params, context?: HttpContext): Observable<void> {
    return this.updateTemplateDynamicFormsSchema$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `importTemplates()` */
  static readonly ImportTemplatesPath = '/v0/templates/import';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importTemplates()` instead.
   *
   * This method sends `text/csv` and handles request body of type `text/csv`.
   */
  importTemplates$Response(params: ImportTemplates$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return importTemplates(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importTemplates$Response()` instead.
   *
   * This method sends `text/csv` and handles request body of type `text/csv`.
   */
  importTemplates(params: ImportTemplates$Params, context?: HttpContext): Observable<void> {
    return this.importTemplates$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `exportTemplates()` */
  static readonly ExportTemplatesPath = '/v0/templates/export';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportTemplates()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportTemplates$Response(params: ExportTemplates$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return exportTemplates(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportTemplates$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportTemplates(params: ExportTemplates$Params, context?: HttpContext): Observable<string> {
    return this.exportTemplates$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

}
